import { updateClipboard } from 'utils/clipboard';
import { NEW_WORKFLOW_ID } from '../constants';
import { NodeId } from '../types';

export const copyLinkToNode = ({ nodeId, workflowId }: { nodeId: NodeId; workflowId?: number }) => {
  if (typeof workflowId === 'undefined' || workflowId === NEW_WORKFLOW_ID) {
    return Promise.reject(new Error('Cannot copy links to nodes in unsaved workflows'));
  }

  const copyText = `${window.location.origin}/workflows/${workflowId}/edit?mode=beta&nodeid=${nodeId}`;

  return updateClipboard(copyText).catch(() => {
    throw new Error('Unable to copy link to clipboard.  Please try again.');
  });
};
